import {CheckoutFragment} from '../../../../gql/graphql';
import {Checkout, ModelContext} from '../../../../types/checkoutApp.types';
import {AdditionalFeeModel} from './AdditionalFee.model';
import {ViolationModel} from './Violation.model';
import {PaymentSummaryModel} from './PaymentSummary.model';
import {PriceSummaryModel} from './PriceSummary.model';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {ErrorsModel} from '../Errors.model';

export class CartSummaryModel {
  public additionalFees: AdditionalFeeModel[];
  public violations: ViolationModel[];
  public paymentSummary: PaymentSummaryModel;
  public priceSummary: PriceSummaryModel;
  public errors: ErrorsModel;

  constructor(params: CartSummaryModel) {
    this.additionalFees = params.additionalFees;
    this.violations = params.violations;
    this.paymentSummary = params.paymentSummary;
    this.priceSummary = params.priceSummary;
    this.errors = params.errors;
  }

  public static fromCheckoutV1(checkout: CheckoutFragment, modelContext: ModelContext) {
    return new CartSummaryModel({
      additionalFees: (checkout.additionalFees ?? [])
        .filter((fee) => !!fee)
        .map((additionalFee) => AdditionalFeeModel.fromCheckoutV1(additionalFee, modelContext)),
      violations: mapViolations(checkout),
      paymentSummary: PaymentSummaryModel.fromCheckoutV1({
        requiresPaymentAfterGiftCard: checkout.paymentRequired,
        totalAfterGiftCards: checkout.totalAfterGiftCard,
        payNow: checkout.payNowTotalAfterGiftCard,
        payLater: checkout.payLater,
        payAfterFreeTrial: checkout.payAfterFreeTrial,
        giftCard: checkout.giftCard,
        modelContext,
      }),
      priceSummary: PriceSummaryModel.fromCheckoutV1(modelContext, mapNullToUndefined(checkout.priceSummary)),
      errors: new ErrorsModel(mapNullToUndefined(checkout.calculationErrors)),
    });
  }
}

function mapViolations(checkout: Checkout): ViolationModel[] {
  return (checkout.violations ?? /* istanbul ignore next */ [])
    .filter((violation) => Boolean(violation))
    .map((violation) => ViolationModel.fromCheckoutV1(violation!));
}
